import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CASHDELIVERY_CONFIRM = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'CASHDELIVERY_CONFIRM')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/jollychic-service/cashdeliver/submit',
        method: 'POST',
        body: data,
        requestAction: CASHDELIVERY_CONFIRM.INIT_REQUEST,
        successAction: CASHDELIVERY_CONFIRM.INIT_SUCCESS,
        success: function(result) {
          dispatch(replace('/cashDelivery/result'))
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CASHDELIVERY_CONFIRM.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CASHDELIVERY_CONFIRM.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'cashDeliveryConfirm',
    reducerMap: {
      cashDeliveryConfirmState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
